<style scoped lang="scss">

</style>

<template>
<div>
  <h2>{{ __('tenant.inc_attestation') }}</h2>

  <div class="uk-width-1-1 uk-margin-bottom">
    <p>
      {{ __(`tenant.inc_attestation_intro`, {amount: formatMoney(lmi), members: application.household.members.length}) }}
    </p>
    <p>Select one of the following:</p>
    <div class="uk-margin-bottom" v-if="!programSettings['hide-monthly-income-on-attestation']">
      <label for="attest_inc_monthly">
        <input v-model="selection" value="month" type="radio" id="attest_inc_monthly">
        {{ __(`tenant.inc_attestation_monthly`) }}
      </label>
      <div class="uk-margin-top uk-grid uk-margin-left" v-if="selection === 'month'">
        <validated-section :errors="errors" field="income_amount">
          <currency-input :currency="{ prefix: '$ '}"
                        v-model="income.income_amount"
                        @change="onIncomeUpdated"
                        class="uk-input uk-width-1-1"
                        placeholder="Income Amount"></currency-input>
        </validated-section>

      </div>

    </div>

    <div class="uk-margin-bottom">
      <label for="attest_inc_annual">
        <input v-model="selection" value="year" type="radio" id="attest_inc_annual">
        {{ __(`tenant.inc_attestation_annual`, {year: application.tax_year}) }}
      </label>
      <div clas="uk-margin-top uk-grid uk-margin-left" v-if="selection === 'year'">
        <validated-section :errors="errors" field="income_amount">
          <currency-input :currency="{ prefix: '$ '}"
                        v-model="income.income_amount"
                        @change="onIncomeUpdated"
                        class="uk-input uk-width-1-1"
                        placeholder="Income Amount"></currency-input>
        </validated-section>

      </div>

    </div>

    <div class="uk-margin-bottom">
      <label for="attest_inc_no_income">
        <input v-model="selection" value="none" type="radio" id="attest_inc_no_income">
        {{ __(`tenant.inc_attestation_no_income`) }}
      </label>
    </div>

    <div class="uk-margin-bottom">
      <label for="attest_inc_decline">
        <input v-model="selection" value="decline" type="radio" id="attest_inc_decline">
        {{ __(`tenant.inc_attestation_decline`) }}
      </label>
    </div>

  </div>

  <validated-section :errors="errors" field="selection">
  &nbsp;
  </validated-section>

  <div class="uk-margin-bottom" v-if="!programSettings['hide-ami-on-income-attestation']">
    <h3 v-html="__(`tenant.inc_attestation_80`, { amount: formatMoney(lmi) })"></h3>
  </div>

  <div class="uk-width-1-1 uk-margin-large-top">
    <p v-html="__(`tenant.inc_under_penalty`, { program_abbreviation: program['program_abbreviation'], agency_short_name: program['agency_short_name'], program: program['program_abbreviation'], agency: program['agency_short_name']})"></p>
    <div class="uk-width-1-1 uk-margin-top">
      <validated-section field="signature" :errors="errors">
        <signature-box @updated="onSignatureUpdated"
                       :user-key="member.id"
                       type-key="income-attestation-amount"
                       :is-signed="signatureData[member.id] && signatureData[member.id].signed_at !== null"
                       :completed="signatureData[member.id] && signatureData[member.id].completed"
                       :name="member.first_name + ' ' + member.last_name"
                       :color="programSettings['primary-program-color']"
        ></signature-box>
      </validated-section>
    </div>
  </div>
</div>
</template>

<script>
import ValidatedSection from "../../Common/ValidatedSection";
import SignatureBox from "../SignatureBox";
import {mapGetters, mapState} from "vuex";
import accounting from 'accounting';

export default {
  name: "IncomeAttestationType",
  props: {
    label: {
      type: String,
      default: ''
    },
    member: {
      type: Object,
      default: {}
    },
    members: {
      type: Array,
      default: []
    },
    url: {
      type: String,
      default: ''
    },
  },
  components: {
    ValidatedSection,
    SignatureBox,
  },
  data() {
    return {
      signatureData: {},
      errors: {},
      incomes: [],
      type: 'attestation',
      selection: null,
      income: {
        id: null,
        type: 'attestation',
        interval: 'annually',
        income_amount: 0,
        attestations: [],
        has_other_members: false,
        other_members: [],
        doc_type: 'none',
      }
    }
  },
  computed: {
    totalRequested() {
      if(this.income.interval === 'annually') {
        return this.income.income_amount;
      }
      if(this.income.interval === 'monthly') {
        return this.income.income_amount * 12;
      }
      return 0;
    },
    ...mapState('Application', {
      application: 'application',
      applicant: 'applicant',
      lmi: 'lmi',
    }),
    ...mapGetters('Application', [
      'program',
      'programSettings'
    ]),
    ...mapState('App', {
      env: state => state.env,
    }),
  },
  watch: {
    selection(newValue) {
      this.income.income_amount = 0;
      if(newValue === 'month') {
        this.income.interval = 'monthly';
        this.onIncomeUpdated();
      }else if(newValue === 'year') {
        this.income.interval = 'annually';
        this.onIncomeUpdated();
      }else if(newValue === 'decline'){
        this.$emit('declined');
        this.$nextTick(() => {
          this.selection = null;
        })
      }else if(newValue === 'none'){
        this.$emit('noIncome');
        this.$nextTick(() => {
          this.selection = null;
        })
      }

    }
  },
  mounted() {
    this.initData();
  },
  methods: {

    initData() {
      this.signatureData = {};
      const signatureFiltered = this.member.signatures.find(item => item.key === `income-attestation-amount`)
      if(signatureFiltered) {
        this.$set(this.signatureData, this.member.id, { key: this.member.id, typeKey: 'income-attestation-amount', signed_at: signatureFiltered.created_at, completed: true });
      }

      if (this.member.incomes && this.member.incomes.length)
      {
        const filteredIncomes = this.member.incomes.filter(item => item.type === this.type)
        this.incomes = filteredIncomes
        let income = filteredIncomes.length > 0 ? _.first(filteredIncomes) : this.income;

        if(income.interval === 'annually') {
          this.selection = 'year';
        }
        if(income.interval === 'monthly') {
          if (!this.programSettings['hide-monthly-income-on-attestation'])
            this.selection = 'month';
          else
          {
            income.interval = 'annually'
            income.income_amount = income.income_amount * 12;
            this.selection = 'year';
          }
        }

        this.$nextTick(() => {
          this.$set(this, 'income', income);
          this.$set(this, 'incomes', [income]);
          this.$emit('updated', {
            member: this.member, amounts: [this.income],
          })
        })
        // this.$set(this, 'income', income);
        // this.income = income;
      }
    },

    onIncomeUpdated() {
      this.incomes = [this.income];
      let args = {
        member: this.member,
        amounts: [this.income],
        signatureData: this.signatureData ? this.signatureData : {},
      };
      this.$emit('updated', args)
    },

    onSignatureUpdated($event) {
      if(!this.signatureData[$event.key]) {
        this.$set(this.signatureData, $event.key, {});
      }
      this.$set(this.signatureData, $event.key, { typeKey: $event.typeKey, signed_at: $event.isSigned ? moment().format('YYYY-MM-DD HH:mm') : null});

      this.onIncomeUpdated();
    },

    validate() {
      this.errors = {};

      let incomeOverLimitStatusId = this.programSettings['income-over-limit-status-id'];
      if(incomeOverLimitStatusId && this.lmi && this.totalRequested > this.lmi) {
        console.log('setting error on step')
        this.$set(this.errors, 'income_amount', { errors: 'You must select an amount lower than the LMI of ' + accounting.formatMoney(this.lmi) + ' to continue.'});
        return false;
      }


      if(this.selection === null) {
        this.errors['selection'] = { errors: 'You must select an item above.'}
      }

      if(this.income.income_amount === 0) {
        this.errors['income_amount'] = { errors: 'You must enter an amount greater than zero.'}
      }

      let signed = false;
      if(this.signatureData[this.member.id] && this.signatureData[this.member.id].signed_at !== null) {
        signed = true;
      }

      if(!signed) {
        this.errors['signature'] = { errors: 'You must sign here to continue.'}
      }

      return _.size(this.errors) === 0;
    },

    formatMoney(amount) {
      return accounting.formatMoney(amount);
    }
  }
}
</script>
